export const ROLES = {
  GESTION: 'gestion',
  TECNICOS: 'tecnicos',
  CIUDADANIA: 'ciudadania',
};

export const ROLE_CONFIG = {
  gestion: {
    label: 'Gestión Interna',
    description: 'Personal de Valoriza Servicios Medioambientales',
    color: '#0A2540',
    route: '/gestion',
  },
  tecnicos: {
    label: 'Técnicos Municipales',
    description: 'Servicios Técnicos del Ayuntamiento (STM)',
    color: '#1E5AA8',
    route: '/tecnicos',
  },
  ciudadania: {
    label: 'Ciudadanía',
    description: 'Vecinos y usuarios del Ecoparque',
    color: '#7DB9E8',
    route: '/ciudadania',
  },
};

export const TEST_CREDENTIALS = [
  {
    email: 'admin@valoriza.com',
    password: 'gestion123',
    role: ROLES.GESTION,
    name: 'Admin Valoriza',
    display: 'admin@valoriza.com / gestion123',
  },
  {
    email: 'tecnico@alcazares.es',
    password: 'tecnicos123',
    role: ROLES.TECNICOS,
    name: 'Técnico STM',
    display: 'tecnico@alcazares.es / tecnicos123',
  },
];
